import React from 'react';
import { useDispatch } from 'react-redux';
import {
  TextField,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button
} from '@material-ui/core';

export default function CursosComplementares(props) {
  const dispatch = useDispatch();
  const extracurricularActivitie = props.extracurricularActivitie;
  const [textButton, setTextButton] = React.useState("Salvar")

  const [id, setId] = React.useState("")
  const [title, setTitle] = React.useState("")
  const [college, setCollege] = React.useState("")
  const [completion_date, setCompletion_date] = React.useState("")

  function onDelete() {
    props.onDelete(id)
  }

  function salvar() {
    if (title !== "" &&
      college !== "" &&
      completion_date !== "") {
      if (extracurricularActivitie !== undefined) {
        props.onSubmit(id, title, college, completion_date);
      } else {
        props.onSubmit("", title, college, completion_date);
      }
    } else {
      dispatch({
        type: 'OPEN_ALERT_DIALOG',
        title: 'Cursos Complementares',
        description: 'Todos os campos são obrigatorios'
      })
    }
  }

  React.useEffect(() => {
    if (extracurricularActivitie !== undefined) {
      setId(extracurricularActivitie.id)
      setTitle(extracurricularActivitie.title)
      setCollege(extracurricularActivitie.college)
      setCompletion_date(extracurricularActivitie.completion_date.substring(0, 10))

      setTextButton("Atualizar")
    }

  }, [extracurricularActivitie])

  return (
    <>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  required
                  id="outlined-required"
                  label="Curso"
                  placeholder='Curso'
                  variant="outlined"
                  fullWidth
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={7}>
                <TextField
                  required
                  id="outlined-required"
                  label="Instituição de Ensino"
                  placeholder='Instituição de Ensino'
                  variant="outlined"
                  fullWidth
                  value={college}
                  onChange={(e) => setCollege(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={5} >
                <TextField
                  id="date"
                  label="Data de Conclusão"
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={completion_date}
                  onChange={(e) => setCompletion_date(e.target.value)}
                />
              </Grid>
            </Grid>
          </CardContent>
          <CardActions>
            <Button size="medium" color="primary" onClick={() => salvar()}>
              {textButton}
            </Button>
            {id !== "" &&
              <Button size="medium" color="secondary" onClick={() => onDelete()}>
                Excluir
            </Button>
            }
          </CardActions>
        </Card>
      </Grid>
    </>
  );
}